<template>
  <v-select
    :items="templateList"
    item-value="id"
    item-text="name"
    v-model="idValue"
    label="Document Template"
    :readonly="readonly"
    :rules="[requiredCheck()]"
    outlined
    dense
  ></v-select>
</template>

<script>
import { mapActions } from 'vuex'
import { required } from '@/lib/formValidations'

// Self-contained (not backed by the shared documentTemplates list module) so this dropdown
// doesn't fight DocumentTemplateList.vue over the same list state when both are mounted.
export default {
  props: [
    'id',
    'isRequired',
    'readonly'
  ],
  data () {
    return {
      templateList: []
    }
  },
  computed: {
    idValue: {
      get () {
        return this.id
      },
      set (newValue) {
        this.$emit('templateIdChange', newValue)
      }
    }
  },
  methods: {
    ...mapActions('documentTemplates', ['getActiveDocumentTemplateOptions']),
    requiredCheck () {
      return !this.isRequired || required('Document Template')
    },
    loadTemplates () {
      this.getActiveDocumentTemplateOptions({ isActive: true })
        .then(templates => { this.templateList = templates })
    }
  },
  created () {
    this.loadTemplates()
  }
}
</script>
